import { render } from "./UserNotificationList.vue?vue&type=template&id=9c9e6542"
import script from "./UserNotificationList.vue?vue&type=script&lang=js"
export * from "./UserNotificationList.vue?vue&type=script&lang=js"

import "./UserNotificationList.vue?vue&type=style&index=0&id=9c9e6542&lang=css"

import exportComponent from "/root/esg_nexus/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__